<template>
  <div style="padding-bottom:30px;display:flex;flex-direction:column;justify-content:center;align-items:center;">
    <el-card style="width:600px;margin-top:30px;">
        <h3>请从 store-server 命令的输出获取管理后台地址</h3>
    </el-card>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  data() {
    return {
    };
  },
  created() {
      if(this.$route.query.amapjskey && this.$route.query.amapjssecret && this.$route.query.domain){
          localStorage.setItem('amapjskey', this.$route.query.amapjskey);
          localStorage.setItem('amapjssecret', this.$route.query.amapjssecret);
          localStorage.setItem('domain', this.$route.query.domain);
          location.href = '/';
      }
  },
  methods: {
  }
};
</script>

<style lang="scss">
.sign-content {
  height: calc(100vh - 80px);
  background-color: white;
}
.el-input--suffix .el-input__inner {
  padding-right: 90px;
}
.sign-verify_code {
  padding-right: 5px;
  font-size: 12px;
  cursor: pointer;
  color: #888;
}
</style>
